import { Suspense, lazy } from 'react';

import type { WhiteBoardCanvasPropsType } from './WhiteboardCanvas';
import { WhiteboardLoader } from './WhiteboardLoader';

const WhiteboardCanvas = lazy(() => import('./WhiteboardCanvas'));
export function LazyWhiteboardCanvas(props: WhiteBoardCanvasPropsType) {
  return (
    <Suspense fallback={<WhiteboardLoader />}>
      <WhiteboardCanvas {...props} />
    </Suspense>
  );
}
